import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";
import DataTable, { TableStyles } from 'react-data-table-component';

import moment from "moment";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import GridPanel from "./grid-panel";

import Helpers from "../../../../utils/helpers";

interface ColumnDef {
  header?: string;
  body?: any;
  name?: any;
  cell?: any;
  selector?: any;
  sortable?: boolean;
  style?: any;
  width?: any;
}
const dataTableStyles: TableStyles = {
  subHeader: {
    style: {
      paddingLeft: "0",
      paddingRight: "0",
    },
  },
  head: {
    style: {
      height: "38px",
      opacity: "1",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#e5e5e5",
      borderTop: "1px solid rgba(0,0,0,0.07)",
      justifyContent: "space-between",
      fontWeight: "bold",
      paddingLeft: "13px",
      paddingRight: "13px",
      height: "38px",
      opacity: "1",
      minWidth:"150px"
    },
  },
  cells: {
    style: {
      /* borderLeft: "1px solid rgba(0,0,0,0.07)",
      "&:last-of-type": {
        borderRight: "1px solid rgba(0,0,0,0.07)",
      }, */
      background: "transparent",
      borderBottom: "#D0D0CE",
      paddingLeft: "13px",
      paddingRight: "13px",
      minHeight: "38px",
    },
  },
  table :{
    style:{
      padding:"15px",
    }
  }
};

interface Customer {
  SurveyName?: string;
  name?: string;
  Date?: string;
  Status?: any;
  Source?: any;
  Size?: any;
  Percent?: number;
}

const AllSurveyTable = (props: any) => {
  const { t } = useTranslation();
  var navigate = useNavigate();
  const selectDaysDpDown1 = useRef<any>(null);
  const [currentPageData, setCurrentPageData] = useState<Customer[]>([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedCustomerID, setSelectedCustomerID] = useState("");

  const session = window.localStorage;
  useEffect(() => {
    if (props?.filteredValues?.length > 0) {
      var filtered_by_size_array = props?.filteredValues;
      let selected_size_low = "";
      let selected_size_medium = "";
      let selected_sizes_high = "";

      if (props?.filterBySize?.length > 0) {
        props?.filterBySize.map((size_val: any) => {
          if (size_val.name == "Low") {
            selected_size_low = "low";
          } else if (size_val.name == "Medium") {
            selected_size_medium = "medium";
          } else if (size_val.name == "High") {
            selected_sizes_high = "high";
          }
        });

        filtered_by_size_array = props?.filteredValues.filter(
          (map_vals: any) => {
            let return_flag = false;

            map_vals.Leaks.map((leaks_val: any) => {
              if (
                (selected_size_low == "low" &&
                  leaks_val.size == "low" &&
                  leaks_val.totalLeaks > 0) ||
                (selected_size_medium == "medium" &&
                  leaks_val.size == "medium" &&
                  leaks_val.totalLeaks > 0) ||
                (selected_sizes_high == "high" &&
                  leaks_val.size == "high" &&
                  leaks_val.totalLeaks > 0)
              ) {
                return_flag = true;
              }
            });
            return return_flag;
          }
        );
      }
      setCurrentPageData(filtered_by_size_array);
    } else {
      setCurrentPageData([]);
    }
    let selected_dashboard_customer_name: any = JSON.parse(
      session.getItem("customer-selected") as any
    );

    if (selected_dashboard_customer_name != "") {
      setSelectedCustomer(
        selected_dashboard_customer_name?.dashboardSelectedCustomer?.name
      );
      setSelectedCustomerID(
        selected_dashboard_customer_name?.dashboardSelectedCustomer?.customerID
      );
    }
  }, [props]);
  const columns: ColumnDef[] = [
    // {
    //   name: "Site ID",
    //   selector: (row: any) => row.siteID,
    //   cell: (row: any) => {
    //     return <>{row.siteID}</>;
    //   },
    //   sortable: true,
    //   // width: '19%'
    // },

    {
      name: "Site Name",
      selector: (row: any) => {
        let temp_site_name = row.siteName;
        if(temp_site_name == null || temp_site_name == undefined){
          temp_site_name = "";
        }

        return temp_site_name;
      },
      cell: (row: any) => {
        return <>{row.siteName}</>;
      },
      sortable: true,
      width: '20%'
    },
    {
      name: "Area",
      selector: (row: any) => {
        let temp_area = row.area;
        if(temp_area == null || temp_area == undefined){
          temp_area = "";
        }

        return temp_area;
      },
      cell: (row: any) => {
        return row.area;
      },
      sortable: true,
      width: '12%',
    },
    {
      name: "Date",
      selector: (row: any) => row.createdOn,
      cell: (row: any) => {
        return Helpers.ConvertUtcToLocalReadable(row.createdOn);
      },
      width: "13%",
      sortable: true,
    },

    {
      name: "Camera operator",
      selector: (row: any) => {
        let temp_operator = row.operator;
        if(temp_operator == null || temp_operator == undefined){
          temp_operator = "";
        }

        return temp_operator;
      },
      cell: (row: any) => {
        return row.operator;
      },
      width: "20%",
      sortable: true,
    },
    {
      name: "Camera Name",
      selector: (row: any) => {
        let temp_cameraName = row.cameraName;
        if(temp_cameraName == null || temp_cameraName == undefined){
          temp_cameraName = "";
        }

        return temp_cameraName;
      },
      cell: (row: any) => {
        return row.cameraName;
      },
      sortable: true,
      width: "15%"
    },
    {
      name: "Leaks Count",
      selector: (row: any) => row.totalLeaks,
      cell: (row: any, index: number, column: any, id: number) => {
        return row.totalLeaks;
      },
      sortable: true,
      width: "10%"
    },
    {
      name: "",
      cell: (row: any, index: number, column: any, id: number) => {
        return (
          <>
            <DetailButtonOverlay row={row} />
          </>
        );
      },
      // width: "5%"
    },
  ];
  const DetailButtonOverlay = (data: any) => {
    const selectDaysDpDown = useRef<any>(null);
    return (
      <>
        <i
          className="pi pi-ellipsis-v"
          style={{ fontSize: "1.5em", cursor: "pointer" }}
          onClick={(e) => selectDaysDpDown.current.toggle(e)}
        ></i>
        <OverlayPanel ref={selectDaysDpDown}>
          <Button
            onClick={() => {
              // console.log(data?.row);
              navigate(
                `/aura-camera/operation-details/${data?.row?.siteID}/${data?.row?.createdOn}`
              );
            }}
          >
            Details
          </Button>
        </OverlayPanel>
      </>
    );
  };
  
  var liveDataCopy:any = currentPageData?.length > 0 ? currentPageData : [];
  var liveData:any;
  if(liveDataCopy?.length > 0){
   liveData = [...liveDataCopy]; // Create a mutable copy of liveData

    liveData.sort(function (a: any, b: any) {
      let aa: any = new Date(a?.createdOn);
      let bb: any = new Date(b?.createdOn);
      return bb - aa;
    });
  }
  // const filteredItems = liveData.filter((item: any) => {
  //   if (item?.name?.toLowerCase().includes(filterText?.toLowerCase()) || (moment(item?.date).format('DD-MMM-YYYY').toLowerCase()).includes(filterText?.toLowerCase()) || item?.status?.toLowerCase().includes(filterText?.toLowerCase())) {
  //     return item;
  //   }
  // })

  const filteredItems = liveData?.filter((item: any) => {
    let regex = /"(\\.|[^"\\])*"/g;
    var exactMatchText: any =
      filterText != null
        ? filterText.match(regex)?.[0].replace(/"/g, "")
        : null;

    if (exactMatchText) {
      return (
        item?.siteID?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.area?.toString().toLowerCase() == exactMatchText?.toLowerCase() ||
        item?.siteName?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        moment(item?.createdOn)
          .format("DD-MMM-YYYY")
          .toString()
          .toLowerCase() == exactMatchText?.toLowerCase() ||
        item?.operator?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.cameraID?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase() ||
        item?.totalLeaks?.toString().toLowerCase() ==
          exactMatchText?.toLowerCase()
      );
    } else {
      return (
        item?.siteID
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.area
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.siteName
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        moment(item?.createdOn)
          .format("DD-MMM-YYYY")
          .toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.operator
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.cameraID
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase()) ||
        item?.totalLeaks
          ?.toString()
          .toLowerCase()
          .includes(filterText?.toLowerCase())
      );
    }
  });

  /*  const handleClearr = useMemo((): any => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  }, [filterText, resetPaginationToggle]);

  useMemo(() => {
    if (props.hmm) {
      handleClearr();
    }
  }, [props.hmm]); */

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      // <FilterComponent onFilter={(e: any) => setFilterText(e?.target?.value)} onClear={handleClear} filterText={filterText} />
      <div className="col-md-12" style={{ marginBottom: "10px" }}>
        <div
          className="d-flex flex-row  justify-content-start align-items-center table-search"
          style={{ maxWidth: "400px" }}
        >
          <label className="custom_common_label">
            {t("SearchLabel")}: &nbsp;&nbsp;&nbsp;{" "}
          </label>
          <div className="inputGroup">
            <div className="input-block">
              <input
                type="text"
                name="sitebulkuploadsearch"
                id="sitebulkuploadsearch"
                className="form-control input-sm"
                autoComplete="off"
                onChange={(e: any) => setFilterText(e?.target?.value)}
                value={filterText}
              />
              <span className="material-symbols-outlined">search</span>
            </div>
            <div className="searchClear">
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => handleClear()}
              >
                {" "}
                X
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      {props.isGrid && props.isGrid ? (
        <div className="grid-block" id="grid-block">
          <div className="row">
            <GridPanel
              filteredItems={liveData}
              selectDaysDpDown={selectDaysDpDown1}
            />
          </div>
        </div>
      ) : (
        <div className="table-responsive" id="table-block">
          <DataTable
            columns={columns}
            data={filteredItems}
            highlightOnHover={true}
            // defaultSortFieldId="3"
            // defaultSortAsc={false}
            pagination={true}
            subHeader
            subHeaderComponent={
              liveData?.length > 0 ? subHeaderComponentMemo : []
            }
            responsive={true}
            striped={true}
            className={"cusTableRes"}
            // paginationPerPage={5}
            // paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
            customStyles={dataTableStyles}
            // sortIcon={sortIcon}
          />
        </div>
      )}
    </>
  );
};

export default AllSurveyTable;
